import { COLOR, LazyImage } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";

export const LIList = styled.li`
  display: list-item;
`;

export const AnchorItem = styled.a`
  display: inline-flex;
  align-items: center;
  vertical-align: bottom;
  min-height: 32px;
  width: 100%;
  text-decoration: none;
  cursor: pointer;
  @media (any-hover: hover) {
    :hover {
      background-color: ${COLOR.GRAY200.code};
      img {
        filter: grayscale(100%) brightness(10);
      }
    }
  }
`;

export const ButtonItem = styled.button`
  display: inline-flex;
  align-items: center;
  height: 32px;
  width: 100%;
  @media (any-hover: hover) {
    :hover {
      background-color: ${COLOR.GRAY200.code};
    }
  }
`;

export const ImageIcon = styled(LazyImage)`
  margin-left: 14px;
  img {
    background: none;
  }
  > picture {
    background: none;
  }
`;

export const SpanMenuNameWithNewTagWrapper = styled.span`
  margin-left: 4px;
`;
